import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
export var noop = function noop() {};
export function on(obj) {
  if (obj && obj.addEventListener) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    obj.addEventListener.apply(obj, _toConsumableArray(args));
  }
}
export function off(obj) {
  if (obj && obj.removeEventListener) {
    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }
    obj.removeEventListener.apply(obj, _toConsumableArray(args));
  }
}
export var isBrowser = typeof window !== 'undefined';
export var isNavigator = typeof navigator !== 'undefined';